module.exports = __webpack_public_path__ + "img/hr-V-R-135-unload-standup-base.cdda0d7e.png";